"use client"

import { ThemeProvider as NextThemesProvider } from "next-themes"

// Follows the system setting by default; a toggle in settings can override it.
export function ThemeProvider({ children }: { children: React.ReactNode }) {
  return (
    <NextThemesProvider
      attribute="class"
      defaultTheme="system"
      enableSystem
      disableTransitionOnChange
    >
      {children}
    </NextThemesProvider>
  )
}
